<template>
  <svg width="190" height="191" viewBox="0 0 190 191" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1947_27870)">
      <circle cx="95" cy="85.5407" r="75" fill="white" />
    </g>
    <circle opacity="0.15" cx="95" cy="85.5406" r="75" :fill="color ?? themeColor.hex" />
    <circle cx="150" cy="31" r="18" fill="white" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M150.062 60.125C166.112 60.125 179.125 47.1168 179.125 31.0625C179.125 15.0175 166.112 2.00001 150.062 2.00001C134.013 2.00001 121 15.0175 121 31.0625C121 47.1168 134.013 60.125 150.062 60.125ZM151.849 15.8024C152.323 16.2762 152.589 16.9188 152.589 17.5888V28.5362H163.536C164.206 28.5362 164.849 28.8024 165.323 29.2761C165.796 29.7499 166.062 30.3925 166.062 31.0625C166.062 31.7325 165.796 32.3751 165.323 32.8489C164.849 33.3227 164.206 33.5888 163.536 33.5888H152.589V44.5362C152.589 45.2062 152.323 45.8488 151.849 46.3226C151.375 46.7963 150.733 47.0625 150.062 47.0625C149.392 47.0625 148.75 46.7963 148.276 46.3226C147.802 45.8488 147.536 45.2062 147.536 44.5362V33.5888H136.589C135.919 33.5888 135.276 33.3227 134.802 32.8489C134.329 32.3751 134.062 31.7325 134.062 31.0625C134.062 30.3925 134.329 29.7499 134.802 29.2761C135.276 28.8024 135.919 28.5362 136.589 28.5362H147.536V17.5888C147.536 16.9188 147.802 16.2762 148.276 15.8024C148.75 15.3287 149.392 15.0625 150.062 15.0625C150.733 15.0625 151.375 15.3287 151.849 15.8024Z"
      :fill="color ?? themeColor.hex" />
    <g clip-path="url(#clip0_1947_27870)">
      <path
        d="M129.551 103.225V117.13C129.551 118.126 129.174 119.085 128.495 119.813C127.816 120.542 126.886 120.985 125.893 121.055C124.175 121.173 122.771 121.236 121.685 121.236C86.9332 121.236 58.7641 93.0668 58.7641 58.3146C58.7641 57.2292 58.8231 55.8253 58.945 54.1067C59.0147 53.1135 59.4585 52.1837 60.1869 51.505C60.9153 50.8262 61.874 50.449 62.8697 50.4494H76.7753C77.2631 50.4489 77.7337 50.6298 78.0956 50.9568C78.4575 51.2839 78.685 51.7337 78.7337 52.2191C78.8242 53.1236 78.9068 53.8433 78.9854 54.3899C79.767 59.8441 81.3686 65.1488 83.736 70.1242C84.1096 70.9107 83.8658 71.8506 83.1579 72.3539L74.6714 78.418C79.8602 90.5085 89.4954 100.144 101.586 105.333L107.642 96.8618C107.89 96.5157 108.251 96.2675 108.663 96.1604C109.074 96.0533 109.511 96.0942 109.896 96.2758C114.87 98.6388 120.174 100.236 125.626 101.015C126.172 101.093 126.892 101.18 127.789 101.266C128.273 101.316 128.722 101.544 129.049 101.906C129.375 102.267 129.551 102.738 129.551 103.225Z"
        :fill="color ?? themeColor.hex" />
    </g>
    <defs>
      <filter id="filter0_d_1947_27870" x="0" y="0.54068" width="190" height="190" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.333333 0 0 0 0 0.431373 0 0 0 0 0.901961 0 0 0 0.13 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1947_27870" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1947_27870" result="shape" />
      </filter>
      <clipPath id="clip0_1947_27870">
        <rect width="94.382" height="94.382" fill="white" transform="translate(46.9663 38.6517)" />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup>
import {useTheme} from "@/stores/ThemeStore";
import {storeToRefs} from "pinia";

const {color: themeColor} = storeToRefs(useTheme());

const props = defineProps({
    color: {
        type: String,
        required: false
    }
});
</script>
